import {
    Module,
    Store,
} from 'vuex';
import { captiveKycStore } from '@accountFederation/store/data/captiveKyc/captiveKycStore';

export function initializeStores(store: Store<unknown>): void {
    registerStores(store);
}

function registerStores(store: Store<unknown>): void {
    registerModule(store, ['data', 'captiveKyc'], captiveKycStore);
}

function registerModule<T>(store: Store<unknown>, path: string[], module: Module<T, unknown>) {
    if (!store.hasModule(path)) {
        store.registerModule(path, module);
    }
}
